<script setup lang="ts">
import type { NotivueItem } from 'notivue'
const { pwaInstallEnd } = storeToRefs(useAuthStore())
const { $pwa } = useNuxtApp()

defineProps<{
  item: NotivueItem<IInstallRequestProps>
}>()

const installPWA = (item: NotivueItem<IInstallRequestProps>) => {
  $pwa?.install()
  pwaInstallEnd.value = true
  item.clear()
}
</script>

<template>
  <div class="w-[380px] max-w-full flex items-start gap-4 p-4 rounded-xl shadow-xl bg-white">
    <div class="flex gap-4 w-full flex-col">
      <div class="flex gap-2 flex-col">
        <p class="text-xl font-bold text-royal-blue-dark">{{ item.title as string }}</p>
        <p class="text-lg text-dark-blue-gray">{{ item.message as string }}</p>
      </div>
      <nav class="w-full flex justify-end gap-4">
        <button
          type="button"
          class="Button"
          :class="[
            ' cursor-pointer py-2 px-4 outline-none text-md font-bold rounded-lg',
            'text-royal-blue-dark bg-transparent border-2 border-solid border-royal-blue-dark',
            'hover:opacity-100 hover:text-white hover:bg-royal-blue-dark',
          ]"
          @click="item.clear"
        >
          Отказаться
        </button>
        <button
          type="button"
          class="Button"
          :class="[
            'cursor-pointer py-2 px-4 outline-none text-md font-bold rounded-lg',
            'bg-royal-blue-dark text-white',
            'hover:opacity-50',
          ]"
          @click="installPWA(item)"
        >
          Принять
        </button>
      </nav>
    </div>
  </div>
</template>
